import React from 'react';
import { Navigate } from 'react-router-dom';

// Mirror AuthGuard: gate on the localStorage `token`, not the cookie (see
// AuthGuard.js for why the cookie is unreliable). Keeps login/authenticated
// routing consistent with the API client's source of truth.
const AuthRedirectGuard = ({ children }) => {
    const isAuthenticated = () => !!localStorage.getItem('token');

    return isAuthenticated() ? <Navigate to="/space" replace /> : children;
};

export default AuthRedirectGuard;
